import { RESPONSIVE_CONTROL_HIT_AREA_CLASS } from "~/lib/touchTarget";

/** Shared context controls use touch targets below md and compact desktop sizing. */
export const STRIP_CONTROL_CLASS = `${RESPONSIVE_CONTROL_HIT_AREA_CLASS} shrink-0 gap-1 rounded-md px-2 font-normal text-muted-foreground/70 hover:text-foreground/80 md:h-6 md:min-h-0 md:min-w-0 md:text-xs`;
